












interface curAccount {
  addtax: string;
  accountBookId: number;
  startPeriod: string;
  endPeriod: string;
}
interface tabs {
  text: string;
  tip: string;
  name: string;
  show: boolean;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { mapGetters } from "vuex";
@Component({
  ...mapGetters(["accountBook"]),
  components: {}
})
export default class SideNav extends Vue {
  @Prop({ type: String })
  activeTab?: string;

  @Prop({ type: Boolean })
  isIncome?: boolean;

  @Prop({ type: Boolean })
  isEITAnnual?: boolean;

  @Prop({ type: Boolean })
  properTax?: boolean;

  @Prop({ type: Boolean })
  landUseTax?: boolean;

  @Prop({ type: Object })
  curAccount?: curAccount;

  get isNormal() {
    if (this.curAccount) {
      return this.curAccount.addtax === "一般纳税人";
    }
    return false;
  }

  // 侧边栏
  tabs: tabs[] = [
    {
      text: "主表",
      tip: "增值税纳税申报表",
      name: this.isNormal ? "generaltaxpayervatdeclaration" : "vatDeclaration",
      show: true
    },
    {
      text: "附表一",
      tip: "本期销售情况明细",
      name: "salesdetails",
      show: this.isNormal
    },
    {
      text: "附表二",
      tip: "本期进项税额明细",
      name: "inputtaxdetails",
      show: this.isNormal
    },
    {
      text: "附表三",
      tip: "服务、不动产和无形资产扣除项目明细",
      name: "isAppendix3",
      show: this.isNormal
    },
    {
      text: "附表四",
      tip: "税额抵减情况表",
      name: "isAppendix4",
      show: this.isNormal
    },
    {
      text: "减免税申报",
      tip: "增值税减免税申报明细表",
      name: "vatcutdeclarations",
      show: true
    }
  ];

  mounted() {
    if (this.properTax) {
      this.tabs = [
        {
          text: "主表从价",
          tip: "主表从价计征",
          name: "PropertyTaxRent",
          show: true
        },
        {
          text: "主表从租",
          tip: "主表从租计征",
          name: "PropertyTaxPrice",
          show: true
        },
        {
          text: "税源信息",
          tip: "房产税税源信息表",
          name: "PropertyTaxInfo",
          show: true
        },
      ]
    }
    if (this.landUseTax) {
      this.tabs = [
        {
          text: "主表",
          tip: "主表",
          name: "LandUseTax",
          show: true
        },
        {
          text: "税源信息",
          tip: "税源信息",
          name: "LandUseTaxInfo",
          show: true
        },
      ]
    }
    if (this.isIncome) {
      this.tabs = [
        {
          text: "主表",
          tip: "所得税月（季）度预缴纳税申报表",
          name: "incomeTaxDeclarationMain",
          show: true
        },
        {
          text: "附表一",
          tip: "免税收入、减计收入、所得减免等优惠明细表",
          name: "incomeTaxDeclarationTwo",
          show: true
        },
        {
          text: "附表二",
          tip: "固定资产加速折旧（扣除）优惠明细表",
          name: "incomeTaxDeclarationThree",
          show: true
        },
        {
          text: "附表三",
          tip: "减免所得税优惠明细表",
          name: "incomeTaxDeclarationFour",
          show: true
        },
        {
          text: "附表四",
          tip: "居民企业参股外国企业信息报告表",
          name: "incomeTaxDeclarationFive",
          show: true
        },
        {
          text: "附表五",
          tip: "技术成果投资入股企业所得税递延纳税备案表",
          name: "incomeTaxDeclarationSix",
          show: true
        }
      ];
    }
    if (this.isEITAnnual) {
      this.tabs = [
        {
          text: "主表",
          tip: "中华人民共和国企业所得税年度纳税申报表（A类）",
          name: "AnnualEITA100000",
          show: true
        },
        {
          text: "附表一",
          tip: "企业基础信息表",
          name: "AnnualEITA000000",
          show: true
        },
        {
          text: "附表二",
          tip: "纳税调整项目明细表",
          name: "AnnualEITA105000",
          show: true
        },
        {
          text: "附表三",
          tip: "职工薪酬支出及纳税调整明细表",
          name: "AnnualEITA105050",
          show: true
        },
        {
          text: "附表四",
          tip: "资产折旧、摊销及纳税调整明细表",
          name: "AnnualEITA105080",
          show: true
        },
        {
          text: "科目余额表",
          tip: "科目余额表",
          name: "Balance",
          show: true
        }
      ];
    }
  }

  // 切换侧边栏
  changeTab(tab: tabs) {
    let tabName = tab.name;
    this.$emit("update:activeTab", tabName);
    this.$emit("change", tab);
  }

  showTabTip(e: any) {
    e.currentTarget.querySelector(".tab-tip").style.display = "block";
  }

  hideTip(e: any) {
    e.currentTarget.querySelector(".tab-tip").style.display = "none";
  }
}
